function convertLocationName(location: string): string {
  if (!location) {
    return "";
  }
  let reNamedLocation = location.toLowerCase();
  reNamedLocation = reNamedLocation.replace(/ä/g, "a");
  reNamedLocation = reNamedLocation.replace(/å/g, "a");
  reNamedLocation = reNamedLocation.replace(/ö/g, "o");
  reNamedLocation = reNamedLocation.replace(/-/g, "_");
  return reNamedLocation;
}

const priceMap = [
  { max: 100000, value: "1" },
  { max: 200000, value: "2" },
  { max: 300000, value: "3" },
  { max: 400000, value: "4" },
  { max: 500000, value: "5" },
  { max: 600000, value: "6" },
  { max: 700000, value: "7" },
  { max: 800000, value: "8" },
  { max: 900000, value: "9" },
  { max: 1000000, value: "10" },
  { max: 1500000, value: "11" },
  { max: 2000000, value: "12" },
  { max: 99999999, value: "13" },
];

const areaMap = [
  { max: 50, value: "1" },
  { max: 75, value: "2" },
  { max: 100, value: "3" },
  { max: 125, value: "4" },
  { max: 150, value: "5" },
  { max: 175, value: "6" },
  { max: 200, value: "7" },
  { max: 250, value: "8" },
  { max: 300, value: "9" },
  { max: 400, value: "10" },
  { max: 500, value: "11" },
  { max: 99999999, value: "12" },
];

const constructionYearGroups = [
  { value: "1", max: 1880 },
  { value: "2", max: 1900 },
  { value: "3", max: 1910 },
  { value: "4", max: 1920 },
  { value: "5", max: 1930 },
  { value: "6", max: 1940 },
  { value: "7", max: 1950 },
  { value: "8", max: 1960 },
  { value: "9", max: 1970 },
  { value: "10", max: 1980 },
  { value: "11", max: 1990 },
  { value: "12", max: 2000 },
  { value: "13", max: 2010 },
  { value: "14", max: 99999 },
];

function getValueGroupRange(
  minValue = 0,
  maxValue = 99999999,
  conversionMap:
    | typeof priceMap
    | typeof areaMap
    | typeof constructionYearGroups
): string[] {
  const resultArray = [];
  let minGroupFound = false;
  for (let i = 0; i < conversionMap.length; i += 1) {
    const valueObj = conversionMap[i];

    if (!minGroupFound && valueObj.max >= minValue) {
      resultArray.push(valueObj.value);
      minGroupFound = true;
    } else if (minGroupFound && maxValue >= valueObj.max) {
      resultArray.push(valueObj.value);
    } else if (minGroupFound) {
      break;
    }
  }
  return resultArray;
}

const roomCountConverter: Record<string, string> = {
  ONE_ROOM: "1",
  TWO_ROOMS: "2",
  THREE_ROOMS: "3",
  FOUR_ROOMS: "4",
  FIVE_ROOMS: "5",
  MORE_THAN_FIVE_ROOMS: "over5",
};

function getRoomCount(
  converter: typeof roomCountConverter,
  rc?: string | string[]
): string | string[] | null {
  if (!rc) {
    return null;
  }
  if (rc instanceof Array) {
    const arr = [];
    for (let i = 0; i < rc.length; i += 1) {
      arr.push(converter[rc[i]]);
    }
    return arr;
  }
  return converter[rc];
}

export {
  convertLocationName,
  getValueGroupRange,
  priceMap,
  getRoomCount,
  roomCountConverter,
  areaMap,
  constructionYearGroups,
};
